<template>
  <v-stepper v-model="physicalStepperStep" vertical>
    <v-stepper-step :rules="[() => venue_validation]" editable :step="10"
      >{{ $t("screener.save.step.select_venue") }}
      <small>{{ $t("screener.save.step.select_venue.desc") }}</small>
    </v-stepper-step>
    <v-stepper-content v-if="!is_vod_event" :step="10">
      <v-form ref="venue_management">
        <div class="pa-4">
          <v-select
            v-if="
              !is_vod_event &&
              screener.event_type > DEFINES.SCREENER_TYPE.VIRTUAL
            "
            :items="venues.data | published"
            :rules="[rules.required, rules.min_length(1)]"
            v-model="screener.physical_venue_id"
            outline
            :label="$t('screener.save.form.physical_venue')"
            item-value="id"
          >
            <template v-slot:selection="{ item }">
                <div>{{item.name}}</div>
            </template>
            <template v-slot:item="{ item }">
                <div >
                    <div>{{item.name}}</div>
                    <div class="subheading greyDarken1--text">{{item.subtitle}}</div>
                </div>
            </template>
          </v-select>
          <v-text-field
                id="physical_venue_max_seats_purchase_count"
                :label="$t('venue.form.label.max_seats_purchase_count')"
                name="physical_venue_max_seats_purchase_count"
                :rules="[rules.required, rules.numeric]"
                color="primary"
                prepend-icon="$vuetify.icons.rms_agreement"
                type="number"
                v-model="screener.physical_venue_max_seats_purchase_count"
              ></v-text-field>
        </div>
      </v-form>
      <v-card-actions>
        <v-btn color="secondary" dark @click="goToStep(11)">
          {{ $t(`${eventPrefix}.btn.continue`) }}
          <v-icon small>$vuetify.icons.screener_next</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-stepper-content>
    <v-stepper-step :rules="[() => category_validation]" editable :step="11"
      >{{ $t("screener.save.step.set_ticket_pricing") }}
      <small>{{ $t("screener.save.step.set_ticket_pricing.desc") }}</small>
    </v-stepper-step>
    <v-stepper-content v-if="!is_vod_event" :step="11">
      <v-form ref="category_management">
        <div class="pa-4">
          <v-text-field
            v-for="category in DEFINES.SEATS_CATEGORIES"
            :key="category.value"
            v-model="screener.physical_venue_seats_pricing[category.value]"
            :prefix="getCurrencySymbol(selected_company.currency)"
            :label="category.label"
            :rules="[]"
            type="number"
            color="primary"
            placeholder="0.00"
          />
        </div>
        <v-card-actions>
        <v-btn color="secondary" dark @click="updateCategoriesPricing()">
          {{ $t(`${eventPrefix}.btn.continue`) }}
          <v-icon small>$vuetify.icons.screener_next</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
      </v-form>
    </v-stepper-content>
    <v-stepper-step :rules="[() => ticket_discount_validation]" editable :step="12"
      >{{ $t("screener.save.step.set_ticket_types_discount") }}
      <small>{{ $t("screener.save.step.set_ticket_types_discount.desc") }}</small>
    </v-stepper-step>
   <v-stepper-content v-if="!is_vod_event" :step="12">
      <v-form ref="ticket_discount_management">
        <div class="pa-4">
          <v-text-field
              v-for="ticketType in ticketTypes"
              :key="ticketType.value"
              outline
              v-model="screener.physical_venue_ticket_types_discount[ticketType.value]"
              :label="ticketType.label"
              suffix="%"
              :rules="[rules.inBetween(0, 100, screener.physical_venue_ticket_types_discount[ticketType.value])]"
              validate-on-blur
              placeholder="0"
            />
        </div>
        <v-card-actions>
        <v-btn color="secondary" dark @click="updateTicketTypesDiscount()">
          {{ $t(`${eventPrefix}.btn.updateTicketTypesDiscount`) }}
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
      </v-form>
    </v-stepper-content>
  </v-stepper>
</template>
<script>
import rules from "@/validation";
import { mapFields } from "vuex-map-fields";
import { mapState, mapGetters } from "vuex";
import { getCurrencySymbol } from "@/helper";
import DEFINES from '@/defines';

export default {
  name: "ScreenerVenueSave",
  props: {
    is_vod_event: {
      type: Boolean,
      default: false,
    },
    screener: {
      type: Object,
    },
    eventPrefix: {
      type: String,
      default: "screener",
    },
    venue_stepper_validation: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      rules,
      venue_validation: true,
      physicalStepperStep: 10,
      category_validation: true,
      ticket_discount_validation: true,
      copy_venue_stepper_validation : this.venue_stepper_validation
    };
  },
  components: {},
  computed: {
    ...mapGetters("company", {
      selected_company: "getSelectedCompany",
    }),
    ...mapFields("venue", {
      venues: "list",
    }),
    ticketTypes(){
      return DEFINES.SEATS_TICKET_TYPES.filter((ticket_type)=> {
        return (ticket_type.value !=0)
      })
    }
  },
  created() {
    this.setInitilialPhysicalSeatsPricing();
    this.initialisePhysicalTicketTypesDiscount();
  },
  watch: {
    screener: {
      deep: true,
      handler: function () {
        this.$emit("update:screener", this.screener);
      },
    },
    copy_venue_stepper_validation: {
      handler: function () {
        this.$emit(
          "update:venue_stepper_validation",
          this.copy_venue_stepper_validation
        );
      },
    },
  },
  methods: {
    goToStep(step) {
      this.physicalStepperStep = step;
    },
    getCurrencySymbol(currency) {
      return getCurrencySymbol(currency);
    },

    validateSave() {
      // Step 10 - Validate Venue
      if (!this.$refs.venue_management.validate()) {
        this.venue_validation = false;
        this.copy_venue_stepper_validation = false;
        this.physicalStepperStep = 10;
        return false;
      } else {
        this.venue_validation = true;
      }

      // Step 11 - Validate category pricing
      if (!this.$refs.category_management.validate()) {
        this.category_validation = false;
        this.copy_venue_stepper_validation = false;
        this.physicalStepperStep = 11;
        return false;
      } else {
        this.category_validation = true;
      }

    //   // Step 12 - Validate category pricing
      if (!this.$refs.ticket_discount_management.validate()) {
        this.ticket_discount_validation = false;
        this.copy_venue_stepper_validation = false;
        this.physicalStepperStep = 12;
        return false;
      } else {
        this.ticket_discount_validation = true;
      }
      this.copy_venue_stepper_validation = true;
      return true;
    },

    setInitilialPhysicalSeatsPricing() {
      if (this.screener.physical_venue_seats_pricing) {
        return;
      }
      let pricing = new Object();
      pricing[DEFINES.SEAT_CATEGORIES_VALUE['REGULAR']] = null
      pricing[DEFINES.SEAT_CATEGORIES_VALUE['CHEAPER']] = null
      pricing[DEFINES.SEAT_CATEGORIES_VALUE['PREMIUM']] = null
      pricing[DEFINES.SEAT_CATEGORIES_VALUE['DISABLED']] = null
      this.screener.physical_venue_seats_pricing = pricing;
    },

    initialisePhysicalTicketTypesDiscount() {
      if(this.screener.physical_venue_ticket_types_discount){
        return;
      }
      let types = new Object();
      types[DEFINES.SEAT_TICKET_TYPES_VALUE['CHILD']] = 0
      types[DEFINES.SEAT_TICKET_TYPES_VALUE['STUDENT']] = 0
      types[DEFINES.SEAT_TICKET_TYPES_VALUE['SENIOR']] = 0
      this.screener.physical_venue_ticket_types_discount = types;
    },

    async updateCategoriesPricing() {
      await this.$store
        .dispatch("screener/updateCategoriesPricing", {
          screener_id: this.screener.id,
          physical_venue_seats_pricing: this.screener.physical_venue_seats_pricing
        })
        .then((res) => {
          this.goToStep(12);
          // this.$store.dispatch("app/showMessage", {
          //   message: i18n.t("screener.booking.seats.updated.success.message"),
          //   color: "success",
          // });
        })
        .catch((error) => {
          this.$store.dispatch("app/showMessage", {
            message: error.message,
            color: "error",
          });
        });
    },

    async updateTicketTypesDiscount() {
      await this.$store
        .dispatch("screener/updateTicketTypesDiscount", {
          screener_id: this.screener.id,
          physical_venue_ticket_types_discount: this.screener.physical_venue_ticket_types_discount
        })
        .then((res) => {
          // this.$store.dispatch("app/showMessage", {
          //   message: i18n.t("screener.booking.seats.updated.success.message"),
          //   color: "success",
          // });
        })
        .catch((error) => {
          this.$store.dispatch("app/showMessage", {
            message: error.message,
            color: "error",
          });
        });
    },
  },
};
</script>
